module.exports = __webpack_public_path__ + "static/media/Galleries_02.163a57fa.jpg";